define('commons/hardware-config',['commons/config-tree'], function(ConfigTree) {
    //
    // HARDWARE TREE
    //
    var HardwareConfig = function() {
        ConfigTree.apply(this, arguments);
    };
    for ( var element in ConfigTree.prototype) {
        HardwareConfig.prototype[element] = ConfigTree.prototype[element];
    }

    HardwareConfig.prototype.createTitle = function(data, id) {
        var iconCls = 'small';
        var title = '<span class="title hwtree-default-icon hwtree-' + data["class"] + '-icon">';
        title += typeof data.description != "undefined" ? data.description + "<span class='"+iconCls+"'>" + data.id + "</span>" : data.id;
        title += '</span>';
        return title;
    };

    HardwareConfig.prototype.createNode = function(parent, data, id, title, selected) {
        var tooltip = (typeof data.vendor != "undefined" && typeof data.product != "undefined") ? data.vendor + " " + data.product : "";
        return parent.addChildren({
            title : title,
            icons: false, // Display node icons.
            tooltip : tooltip,
            key : id,
            active : selected
        });
    };
    return HardwareConfig;
});
